A deep link to the action.

This is required for a profile action of an uploaded candidate.

The `url` field has a maximum length of 1,000 characters.
